<template>
  <a-modal
    title="编辑处方药品发药退药记录表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="类型  0：发药  1：退药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入类型  0：发药  1：退药" v-decorator="['type', {rules: [{required: true, message: '请输入类型  0：发药  1：退药！'}]}]" />
        </a-form-item>
        <a-form-item
          label="处方流水号(显示在缴费单上)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入处方流水号(显示在缴费单上)" v-decorator="['recipeNo', {rules: [{required: true, message: '请输入处方流水号(显示在缴费单上)！'}]}]" />
        </a-form-item>
        <a-form-item
          label="数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入数量" v-decorator="['medicineNum', {rules: [{required: true, message: '请输入数量！'}]}]" />
        </a-form-item>
        <a-form-item
          label="药品类型  0：西药/中成药  1：中药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品类型  0：西药/中成药  1：中药" v-decorator="['medicineType', {rules: [{required: true, message: '请输入药品类型  0：西药/中成药  1：中药！'}]}]" />
        </a-form-item>
        <a-form-item
          label="药品编码（药品唯一编码，各医疗机构药品编码）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品编码（药品唯一编码，各医疗机构药品编码）" v-decorator="['medicineCode', {rules: [{required: true, message: '请输入药品编码（药品唯一编码，各医疗机构药品编码）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="药品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品名称" v-decorator="['medicineName', {rules: [{required: true, message: '请输入药品名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入规格" v-decorator="['specification', {rules: [{required: true, message: '请输入规格！'}]}]" />
        </a-form-item>
        <a-form-item
          label="剂量单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入剂量单位" v-decorator="['mediUnit', {rules: [{required: true, message: '请输入剂量单位！'}]}]" />
        </a-form-item>
        <a-form-item
          label="创建时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间戳！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="更新时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        </a-form-item>
        <a-form-item
          label="删除标识（0-否，1-是）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入删除标识（0-否，1-是）" v-decorator="['deleteFlag', {rules: [{required: true, message: '请输入删除标识（0-否，1-是）！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baRecipeDrugRecordEdit } from '@/api/modular/interhospital/barecipedrugrecord/baRecipeDrugRecordManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              type: record.type,
              recipeNo: record.recipeNo,
              medicineNum: record.medicineNum,
              medicineType: record.medicineType,
              medicineCode: record.medicineCode,
              medicineName: record.medicineName,
              specification: record.specification,
              mediUnit: record.mediUnit,
              utstamp: record.utstamp,
              deleteFlag: record.deleteFlag
            }
          )
        }, 100)
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            baRecipeDrugRecordEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
